import { makeStateKey, StateKey, TransferState } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import isNumber from 'lodash/isNumber';

interface TransferableStateValue {
  lifetime: number;
  data: any;
}

export class TransferableService {

  constructor(private transferState: TransferState,
              private _platformId: any) {
  }

  protected setToState(key: string, data: any, lifetime?: number) {
    if (isPlatformServer(this._platformId) || !isNumber(lifetime)) {
      lifetime = Number.MAX_SAFE_INTEGER;
    }

    const stateKey: StateKey<TransferableStateValue> = makeStateKey<TransferableStateValue>(key);
    this.transferState.set(stateKey, { lifetime: Date.now() + lifetime, data });
  }

  protected getFromState(key: string, defaultVal: any = null): any {
    const stateKey: StateKey<TransferableStateValue> = makeStateKey<TransferableStateValue>(key);
    const cached = this.transferState.get(stateKey, defaultVal);

    if (cached && cached.lifetime > Date.now()) {
      return cached.data;
    }

    return null;
  }
}
